<template>
  <VDialog
    :value="isOnBoardPaymentAvailableDialogOpen"
    width="425"
    persistent
    outlined
    data-test="onboard-payment-error-dialog"
  >
    <VCard class="w-100">
      <VCardTitle>
        <VRow class="pl-4 py-4">
          <h6
            class="heading-6 textPrimary--text text-center"
            data-test="onboard-payment-error-title"
          >
            {{ $t('checkout.onboardIsNotAvailable') }}
          </h6>
        </VRow>
      </VCardTitle>
      <VCardActions>
        <VBtn
          class="w-100 header__link"
          color="brandingPrimary"
          data-test="onboard-payment-error-ok-button"
          @click="$emit('closeDialog')"
        >
          <span class="button textWhite--text">
            {{ $t('checkout.ok') }}
          </span>
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SOnBoardPaymentErrorDialog',
};
</script>

<script setup lang="ts">
defineProps({
  isOnBoardPaymentAvailableDialogOpen: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="scss" scoped>
</style>
